import { ProductType } from '../../types/forms';
import { StandaloneServicePlanModel } from './formModel';

export const standaloneServicePlanInitialValues: StandaloneServicePlanModel = {
  productType: ProductType.servicePlan,
  servicePlan: '',
  vatApplicable: 'yes', // Hardcoded to yes per PC-2302
  lastProposalDate: '31/07/2023',
  lastActivationDate: '30/09/2023',
  firstRegistrationDate: '',
  recordedKilometers: undefined,
  paymentType: undefined,
  contractDuration: '',
  paymentTerm: '',
  calculation: undefined,
};
